<template>
<div>
	<v-dialog
		v-model="dialog"
		width="1000"
		persistent
	>
		<v-btn
			slot="activator"
			color="indigo"
			@click="cleanForm"
			dark
			class="finance-pay-button"
		>
			{{$t('workers.issue_payment')}}
		</v-btn>

		<v-card>
			<v-card-title
				class="headline light-blue darken-1 white--text"
				primary-title
			>
				{{$t('workers.payment')}}
			</v-card-title>

			<v-card-text>
				<v-container grid-list-lg>
					<v-layout>
						<v-flex md6>
							<v-layout column>
								<v-card-title
									class="headline"
									primary-title
								>
									{{$t('workers.rate_count_day')}}
								</v-card-title>
								<v-flex>
									<v-text-field type="number"
										class="inputPrice"
										:label="$t('workers.rate')"
										v-model="rate"
									/>
								</v-flex>
								<v-flex>
									<v-text-field type="number"
										class="inputPrice"
										:label="$t('workers.counts_day_hours')"
										v-model="count"
									/>
								</v-flex>
							</v-layout>
						</v-flex>
						<v-flex md6>
							<v-layout column>
								<v-card-title
									class="headline"
									primary-title
								>
									{{$t('workers.salary')}}
								</v-card-title>
								<v-flex v-if="salary > 0" d-flex direction-colum>
									<div class="col">
										<span class="col__title">{{$t('workers.salary')}}:</span>
										<span>{{salary}}</span>
									</div>
									<div class="col">
										<span class="col__title">{{$t('workers.prepayment.type_prepay')}}:</span>
										<span>{{prepayment}}</span>
									</div>
									<div class="col last">
										<span class="col__title">{{$t('workers.to_pay')}}:</span>
										<span>{{salary}} - {{prepayment}} = <span class="bold">{{salaryWithoutPrepayment}}</span></span>
									</div>
								</v-flex>
								<v-flex>
									<v-text-field :label="$t('common.comment')"
										v-model="comment"
									/>
								</v-flex>
								<v-flex class="pay-btn" d-flex>
									<ConfirmDialog v-bind="propConfirm" @accept="accept">
										{{$t('workers.pay_salary')}}
									</ConfirmDialog>
								</v-flex>
							</v-layout>
						</v-flex>
					</v-layout>
				</v-container>
			</v-card-text>

			<v-divider />

			<v-card-actions>
				<v-spacer />
				<v-btn
					color="red light-1"
					flat
					@click="close"
				>
					{{$t('common.cancel')}}
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import ConfirmDialog from '../../../../components/ConfirmDialog'
import { notify } from "../../../../utils/notifications";

export default {
	components: {
		ConfirmDialog
	},
	props: ['prepayment'],
	data: (vm) => ({
		dialog: false,
		comment: '',
		rate: 0,
		count: 0,
		propConfirmDialog: {
			message: vm.$t('workers.confirm_pay_salary'),
			title: vm.$t('workers.confirm_salary_title'),
			btnProps: {
				dark: true,
				large: true,
				color: 'green lighten-2'
			}
		}
	}),
	computed: {
		...mapState({
			lastHourlyRate: ({ workers }) => workers.lastHourlyRate
		}),
		salary() {
			if(this.rate > 0 && this.count) {
				let result = parseFloat(this.rate) * parseFloat(this.count)
				return result.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0]
			}
			return 0
		},
		salaryWithoutPrepayment() {
			return (this.salary - this.prepayment).toFixed(2)
		},
		workerName() {
			const worker = this.$store.state.workers.workerDetail
			return worker.firstname + ' ' + worker.lastname
		},
		propConfirm() {
			return {
				...this.propConfirmDialog,
				message: this.$t('workers.confirm_salary', {salary: this.salary, workerName: this.workerName}),
			}
		}
	},
	methods: {
		...mapActions({
			paySalary: 'workers/paySalary',
			makePrepay: 'workers/makePrepay',
			getLastHourlyRate: 'workers/getLastHourlyRate'
		}),
		accept() {
			const data = {
				hourly_rate: parseFloat(this.rate),
				number_hours: parseFloat(this.count),
				amount: this.salaryWithoutPrepayment,
				comment: this.comment ? this.comment : ''
			}
			const errors = []
			if (data.amount < 0) {
				errors.push(this.$t('workers.negative_salary'))
				data.amount = 0
			}
			if (errors.length > 0) {
				alert(errors.join(' '))
			}

			this.paySalary(data).then(() => {
				this.$notify({...notify, text: this.$t('notifications.saved', {type: 'salary'})})
				if(this.salaryWithoutPrepayment < 0) {
					let prepayData = {
						amount: Math.abs(this.salaryWithoutPrepayment),
						comment: '',
						type: 'debt'
					}
					this.makePrepay(prepayData).then(() => {
						this.$notify({...notify, text: this.$t('notifications.saved', {type: 'debt'})})
					})
				}
				this.close()
			})
		},
		close() {
			this.cleanForm()
			this.dialog = false
		},
		cleanForm() {
			this.rate = 0
			this.count = 0
			this.comment = null
		}
	},
	watch: {
		dialog() {
			if(this.dialog) {
				this.getLastHourlyRate()
				.then(() => {
					this.rate = this.lastHourlyRate
				})
			}
		}
	}
}
</script>

<style>
.pay-btn .v-dialog__activator {
	display: flex;
	align-items: center;
	justify-content: center;
	padding-top: 25px;
}
.bold {
	font-weight: bold;
}
.col {
	display: flex;
	flex-direction: column;
	justify-content: left;
	border-right: 1px solid #dedede;
	padding: 0 2px;
}
.last {
	border: none;
}
.col__title {
	color: #ababab;
	font-size: 16px;
}
</style>
